type PencilIconProps = {
  width?: string;
  height: string;
  fill: string;
  onClick?: any;
};
const PencilIcon = ({ width, height, fill, onClick }: PencilIconProps) => {
  return (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.7244 4.3673C25.8353 3.25647 27.6363 3.25647 28.7471 4.3673L30.7584 6.37862C31.8692 7.48945 31.8692 9.29045 30.7584 10.4013L28.7471 12.4126L22.7131 6.37862L24.7244 4.3673Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66045 31.2571L11.9418 29.2179L26.7357 14.4239L20.7017 8.38996L5.90779 23.1839L3.86857 29.4652C3.50985 30.5702 4.55549 31.6158 5.66045 31.2571ZM20.7017 12.4126L22.7131 14.4239L10.4136 26.7234L7.43539 27.6903L8.40225 24.7121L20.7017 12.4126Z"
        fill={fill}
      />
      <path
        d="M21.4049 29.763C22.0761 28.4502 23.9388 28.4133 24.6616 29.6983C26.6095 33.1613 31.7107 32.7878 33.1335 29.0781L33.5503 27.9912C33.8316 27.2578 33.4651 26.4353 32.7317 26.154C31.9983 25.8727 31.1758 26.2392 30.8945 26.9726L30.4777 28.0595C29.9173 29.5207 27.908 29.6678 27.1408 28.3038C25.3056 25.0412 20.5766 25.1351 18.8723 28.4679L18.1562 29.8684C17.7985 30.5678 18.0756 31.4246 18.7749 31.7822C19.4742 32.1399 20.3311 31.8628 20.6887 31.1635L21.4049 29.763Z"
        fill={fill}
      />
    </svg>
  );
};

export default PencilIcon;
